module.exports = __webpack_public_path__ + "img/pr-4.c4dd3a1f.png";